/**
 * Central Configuration
 * Shared configuration for auth and portal applications
 */

const local_config = {
    // API Configuration
    apiURL: 'https://api.mojoware.net',
    apiTimeout: 30000,

    basePath: '/',

    // Portal Configuration
    portalURL: 'http://localhost:8888/',
    authURL: '/auth/',

    // Company Branding
    companyName: 'CAMWARE (Local)',
    logoURL: "/media/camactive_logo_light.png",

    brand: '',
    brandIcon: '',

    termsUrl: '/terms.html',
    privacyUrl: '/privacy.html'

};

const regionalProduction = {
    'portal.mojoaccess.eu': {
        apiURL: 'https://api.mojoaccess.eu',
        portalURL: 'https://portal.mojoaccess.eu/',
        authURL: 'https://portal.mojoaccess.eu/auth/'
    },
    'portal.mojoware.net': {
        apiURL: 'https://api.mojoware.net',
        portalURL: 'https://portal.mojoware.net/',
        authURL: 'https://portal.mojoware.net/auth/'
    }
};

const production_config = {

    // Company Branding
    companyName: 'MOJOWARE',

    logoURL: "/media/mojo_ware_logo.png",

    basePath: '/',

    brand: '',
    brandIcon: '',

    termsUrl: '/terms.html',
    privacyUrl: '/privacy.html'

};

// location.hostname keeps the brackets on IPv6 literals ('[::1]', not '::1').
const isLocalhost = ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname);

let config;
if (isLocalhost) {
    config = local_config;
} else {
    const regional = regionalProduction[window.location.hostname];
    if (!regional) {
        throw new Error(`Unsupported Mojoware portal host: ${window.location.hostname}`);
    }
    config = { ...production_config, ...regional };
}

export default config;
export { local_config, regionalProduction };
